import React, { useCallback } from 'react'

import { DeleteDialog } from '@/components/library-v2/ui/DeleteDialog'

import { useDeletePeople } from '@/hooks/library/useDeletePeople'
import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

import { UUID } from '@/types/Id'

interface DeletePeopleDialogProps {
  personIds: UUID[]
  open: boolean
  setOpen: (isOpen: boolean) => void
  onDelete?: () => void
}

export const DeletePeopleDialog: React.FC<DeletePeopleDialogProps> = ({
  personIds,
  open,
  setOpen,
  onDelete,
}) => {
  const { activeOrgId } = useActiveOrgId()
  const { mutate: deletePeople } = useDeletePeople({
    orgId: activeOrgId,
  })

  const onSubmit = useCallback(() => {
    if (personIds.length > 0) {
      deletePeople(
        { ids: personIds },
        {
          onError: (error) => {
            console.error('Failed to delete people:', error)
          },
        },
      )
      onDelete?.()
    }
  }, [personIds, deletePeople, onDelete])

  return (
    <DeleteDialog
      label={personIds.length === 1 ? 'Person' : `${personIds.length} people`}
      open={open}
      setOpen={setOpen}
      onDelete={onSubmit}
    />
  )
}
